export default {
  "pl": {
    "todo_list": {
      "actions": {
        "add": "Utwórz listę zadań",
        "cancel": "Cofnij",
        "delete_todo_list": "Usuń listę",
        "edit": "Edytuj listę zadań",
        "new": "Nowa lista zadań",
        "save": "Zapisz",
        "title": "Tytuł listy"
      },
      "attributes": {
        "name": "Tytuł"
      },
      "labels": {
        "assignToLevel": "Przypisz do poziomu",
        "newTodoList": "Nowa lista zadań"
      },
      "placeholders": {
        "employees": {
          "new": {
            "subtitle": "Prowadź rejestr zadań do wykonania z zespołem.",
            "title": "Otwórz nową listę zadań"
          }
        }
      },
      "toasts": {
        "create": "Utworzono listę zadań",
        "delete": "Usunięto listę zadań",
        "update": "Zaktualizowano listę zadań"
      },
      "validation": {
        "needTitle": "Należy podać tytuł"
      }
    }
  }
}
